import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c68a1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OSelecionarProjetosGrupo",
  "data-testid": "OSelecionarProjetosGrupo"
}
const _hoisted_2 = ["title"]

import { ref, onMounted, computed, watch, Ref } from "vue"
  import {
    OGrupoAvatar,
    MInput,
    MMultiSelect,
    AEstadoVazioTabela,
    APaginadorDeTabela,
  } from "@/components/Gerais"
  import Column from "primevue/column"
  import DataTable, { DataTableFilterMeta } from "primevue/datatable"
  import PButton from "primevue/button"
  import {
    ListarProjetos,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetosRepositorio from "@/repositorios/projeto/projeto.repositorio"

  import { usarManipuladoresDeTabela } from "@/composable/UsarManipuladoresDeTabela/usarManipuladoresDeTabela"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"

  import tabelaProjetos from "./OSelecionarProjetosGrupo.script"
  import { EntidadeGenerica } from "@/types/gerais"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import { PageState } from "primevue/paginator"
  import { useI18n } from "vue-i18n"

  interface Props {
    usuariosResponsaveisOpcoes: EntidadeGenerica[]
    projetosPreSelecionados: string[]
    alturaRelativaDaTabela?: string
    buscarAtivosEInativos?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OSelecionarProjetosGrupo',
  props: {
    usuariosResponsaveisOpcoes: null,
    projetosPreSelecionados: null,
    alturaRelativaDaTabela: { default: "450px" },
    buscarAtivosEInativos: { type: Boolean, default: false }
  },
  emits: ["update:projetosSelecionados", "update:projetosPreSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:projetosSelecionados", projetosSelecionados: ListarProjetos[])
    (event: "update:projetosPreSelecionados", projetosPreSelecionados: string[])
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { usuariosResponsaveisOpcoes: EntidadeGenerica[], projetosPreSelecionados: string[], alturaRelativaDaTabela: string, buscarAtivosEInativos: boolean }

  

  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0

  const projetosRepositorio = new ProjetosRepositorio()

  const { filtros, preencherFiltro, removerFiltro } = usarFiltragem()
  const { desativarLinhaPorStatus } = usarManipuladoresDeTabela()
  const { leitor } = usarLeitorDeDados()
  const { onErro } = usarMensagemUsuario()

  const { filtrosTabela } = tabelaProjetos()

  const projetosDaPaginaAtual = ref<ListarProjetos[]>([])
  const projetosSelecionados = ref<ListarProjetos[]>([])

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetosRepositorio.listarProjetosFrontend,
    {
      ativo: "igual.true",
      "por-pagina": 1000,
    }
  )

  const estilo = {
    linhas: {
      alturaDaLinha: {
        height: "48px",
      },
    },
  }

  const estaCarregandoProjetos = computed(() => {
    return lerProjetos.resultado.status === "pendente"
  })

  const projetosPreSelecionados = computed({
    get() {
      return props.projetosPreSelecionados
    },
    set(idsPreSelecionados: string[]) {
      emitir("update:projetosPreSelecionados", idsPreSelecionados)
    },
  })

  const subtrairListas = (listaFinal: Ref<ListarProjetos[]>, listaParaSubtrair: Ref<ListarProjetos[]>): void => {
    listaFinal.value = listaFinal.value.filter(
      (itemDaListaFinal) => {
        return !listaParaSubtrair.value.some(
          (itemDaListaParaSubtrair) => itemDaListaParaSubtrair.id === itemDaListaFinal.id
        )
      }
    )
  }

  const subtrairItemDeUmaLista = (listaFinal: Ref<ListarProjetos[]>, itemParaSubtrair: ListarProjetos): void => {
    listaFinal.value = listaFinal.value.filter(
      (itemDaListaFinal) => itemDaListaFinal.id !== itemParaSubtrair.id
    )
  }

  const somarListas = (listaFinal: Ref<ListarProjetos[]>, listaParaSomar: ListarProjetos[]): void => {
  const novosItens = listaParaSomar.filter(item =>
    listaFinal.value.every(finalItem => finalItem.id !== item.id)
  )

  listaFinal.value = [...listaFinal.value, ...novosItens]
}


  const somarItemALista = (listaFinal: Ref<ListarProjetos[]>, itemParaSomar: ListarProjetos): void => {
    listaFinal.value = [...listaFinal.value, itemParaSomar]
  }

  const selecionarProjetos = (event): void => {
    const selecionados = event.data
    const selecionouTodos = selecionados.length > 1

    if (selecionouTodos) {
      somarListas(projetosSelecionados, selecionados)
    } else {
      somarItemALista(projetosSelecionados, selecionados)
    }
    emitir("update:projetosSelecionados", projetosSelecionados.value)
  }

  const desselecionarProjetos = (event): void => {
    // Ao desselecionar todos os projetos, o componente por padrão retorna undefined
    const desselecionouTodos = event.data === undefined

    if (desselecionouTodos) {
      subtrairListas(projetosSelecionados, projetosDaPaginaAtual)
    } else {
      const projetoDesselecionado = event.data
      subtrairItemDeUmaLista(projetosSelecionados, projetoDesselecionado)
    }
    emitir("update:projetosSelecionados", projetosSelecionados.value)
  }

  const listarProjetos = async (
    pagina: number,
    porPagina = 10
  ): Promise<void> => {
    if (props.buscarAtivosEInativos) {
      const parametros = lerProjetos.obterParametros()
      delete parametros.ativo
      lerProjetos.sobrescreverParametros(parametros)
    }

    await lerProjetos.porPagina(porPagina).pagina(pagina).executar()

    if (lerProjetos.resultado.status === "sucesso") {
      projetosDaPaginaAtual.value = lerProjetos.resultado.dados
      definirItensPreSelecionados()
    }

    if (lerProjetos.resultado.status === "vazio") {
      projetosDaPaginaAtual.value = []
    } else if (lerProjetos.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarProjetos"),
        detalhes: t("ocorreuUmErroAoBuscarOsProjetos"),
      })
    }
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ): Promise<void> => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]
    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)
    filtrarProjetos()
  }

  const filtrarProjetos = async (): Promise<void> => {
    lerProjetos.sobrescreverParametros({
      ...filtros.value,
      ativo: "igual.true",
    })

    lerProjetos.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarProjetos(lerProjetos.primeiraPagina, lerProjetos.itensPorPagina)
  }

  const limparFiltros = async (nome, filterCallback): Promise<void> => {
    removerFiltro(nome)
    filterCallback()
    await filtrarProjetos()
  }

  const onPaginarProjetos = async ({
    page,
    rows,
  }: PageState): Promise<void> => {
    await listarProjetos(page, rows)
  }

  const carregarDados = async (): Promise<void> => {
    await listarProjetos(lerProjetos.primeiraPagina)
  }

  const definirItensPreSelecionados = (): void => {
    const naoTemProjetosPreSelecionados =
      projetosPreSelecionados.value.length === 0
    if (naoTemProjetosPreSelecionados) {
      return
    }

    const pegarPreSelecionadosDaPaginaAtual = (): ListarProjetos[] => {
      return projetosDaPaginaAtual.value.filter((projeto) => {
        return projetosPreSelecionados.value.includes(projeto.id)
      })
    }

    const removerRecemSelecionadosDaListaDePreSelecionados = (): string[] => {
      return projetosPreSelecionados.value.filter((projetoPreSelecionado) => {
        return !projetosPreSelecionadosEncontrados.some((projeto) => {
          return projeto.id === projetoPreSelecionado
        })
      })
    }

    const projetosPreSelecionadosEncontrados =
      pegarPreSelecionadosDaPaginaAtual()

      projetosSelecionados.value = [
      ...projetosSelecionados.value,
      ...projetosPreSelecionadosEncontrados,
    ]

    projetosPreSelecionados.value =
    removerRecemSelecionadosDaListaDePreSelecionados()

    emitir("update:projetosSelecionados", projetosSelecionados.value)
  }

  watch(
    () => props.projetosPreSelecionados,
    (novoValor, valorAntigo) => {
      if (valorAntigo.length === 0 && novoValor.length > 0) {
        definirItensPreSelecionados()
      }
    }
  )

  onMounted(async () => {
    try {
      await carregarDados()
    } catch (erro) {
      console.error(erro)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      filters: _unref(filtrosTabela),
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filtrosTabela) ? (filtrosTabela).value = $event : null)),
      onRowSelect: selecionarProjetos,
      onRowSelectAll: selecionarProjetos,
      onRowUnselect: desselecionarProjetos,
      onRowUnselectAll: desselecionarProjetos,
      class: "OSelecionarProjetosGrupo__DataTable p-datatable-sm",
      "data-key": "codigo",
      "data-testid": "OSelecionarProjetosGrupo__DataTable",
      "filter-display": "menu",
      "global-filter-fields": ['nomeProjeto', 'codigo', 'usuariosResponsaveis'],
      loading: _unref(estaCarregandoProjetos),
      "meta-key-selection": false,
      "responsive-layout": "scroll",
      "row-class": _unref(desativarLinhaPorStatus),
      "row-style": estilo.linhas.alturaDaLinha.height,
      rows: _unref(lerProjetos).itensPorPagina,
      "scroll-height": `calc(100vh - ${__props.alturaRelativaDaTabela})`,
      scrollable: "",
      selection: projetosSelecionados.value,
      "selection-mode": "multiple",
      "striped-rows": "",
      value: projetosDaPaginaAtual.value
    }, _createSlots({
      loading: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          height: "100%",
          width: "100%"
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(APaginadorDeTabela), {
          "ao-paginar": onPaginarProjetos,
          leitor: _unref(lerProjetos)
        }, null, 8, ["leitor"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          "header-style": "width: 44px; flex: unset;",
          "selection-mode": "multiple",
          style: {"flex":"0"}
        }),
        _createVNode(_unref(Column), {
          class: "OSelecionarProjetosGrupo__Column OSelecionarProjetosGrupo__Nome",
          field: "nomeProjeto",
          "filter-field": "nome_projeto",
          header: _unref(t)('nome'),
          "show-add-button": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              class: "quebrar-texto-em-duas-linhas",
              "data-testid": "OSelecionarProjetosGrupo__Dado",
              title: data.nomeProjeto
            }, _toDisplayString(data.nomeProjeto), 9, _hoisted_2)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-nome-do-projeto",
              placeholder: _unref(t)('pesquisarPorNomeDoProjeto'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros('nome_projeto', filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OSelecionarProjetosGrupo__Column OSelecionarProjetosGrupo__Codigo",
          field: "codigo",
          "filter-field": "codigo",
          header: _unref(t)('codigo'),
          "show-add-button": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data: projeto }) => [
            _createTextVNode(_toDisplayString(projeto.codigo), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-codigo",
              placeholder: _unref(t)('pesquisarPorCodigoDoProjeto'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OSelecionarProjetosGrupo__Column OSelecionarProjetosGrupo__UsuariosResponsaveis",
          "data-type": "multiselect",
          field: "usuariosResponsaveis",
          "filter-field": "usuarios_responsaveis",
          header: _unref(t)('usuariosResponsaveis'),
          "show-add-button": false,
          "show-filter-match-modes": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(OGrupoAvatar), {
              identificadores: data.usuariosResponsaveis,
              "limitar-quantidade-em": 15,
              "requisitar-avatares-por-id": ""
            }, null, 8, ["identificadores"])
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MMultiSelect), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "OAcordeaoProjetos__MMultiselect",
              "exibicao-de-opcoes": "comma",
              filter: true,
              "maximo-de-legendas-selecionadas": 3,
              nome: "filtro-usuarios-responsaveis",
              "option-label": "nome",
              "option-value": "id",
              options: __props.usuariosResponsaveisOpcoes,
              placeholder: _unref(t)('pesquisarPorUsuarioResponsavel')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 2
    }, [
      (!_unref(estaCarregandoProjetos))
        ? {
            name: "empty",
            fn: _withCtx(() => [
              _createVNode(_unref(AEstadoVazioTabela))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["filters", "loading", "row-class", "row-style", "rows", "scroll-height", "selection", "value"])
  ]))
}
}

})